import { useEffect } from 'react'
import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'

import type { Channel } from '../../../../../common/types'

interface UseChannelConnectionTrackingArgs {
  organizationId?: string
  channel?: Channel
  commonTrackingProperties?: Record<string, unknown>
}

export function useChannelConnectionTracking({
  organizationId,
  channel,
  commonTrackingProperties,
}: UseChannelConnectionTrackingArgs): void {
  useEffect(() => {
    if (organizationId && channel?.id) {
      BufferTracker.channelConnectionGoalModalViewed({
        organizationId,
        channelId: channel.id,
        channelUsername: channel.name,
        channelService: channel.service,
        clientName: Client.PublishWeb,
        ...commonTrackingProperties,
      })
    }
  }, [organizationId, channel, commonTrackingProperties])
}

export function trackPostingGoalSkipped({
  organizationId,
  channel,
  commonTrackingProperties,
}: UseChannelConnectionTrackingArgs): void {
  if (organizationId && channel?.id) {
    BufferTracker.postingGoalSkipped({
      organizationId,
      channelId: channel.id,
      channelUsername: channel.name,
      channelService: channel.service,
      clientName: Client.PublishWeb,
      ...commonTrackingProperties,
    })
  }
}
